import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class AuditoriaAlocacaoMOTStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.findAuditoriaAlocacaoMOT(filtro).then(response => {
            this.dados = response.data;

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaAlocacaoMOTExcel(filtro).then(response => {
            fileDownload(response.data, "Auditoria alocação de MOTs.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }

    onExportPdf = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaAlocacaoMOTPdf(filtro).then(response => {
            fileDownload(response.data, "Auditoria alocação de MOTs.pdf");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }
}
